import { Box, Grid, Group, Radio } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { TFunction } from "i18next";
import { Select } from "components";

interface CardCardProps {
  form: UseFormReturnType<any, any>;
  t: TFunction;
}

const CardCard = ({ form, t }: CardCardProps) => {

  return (
    <Box p={'lg'}>
      <Grid>
        <Grid.Col span={3}>
          <Select
            label={t('user.cardOwner.label')}
            placeholder={t('select.something')}
            key={form.key('cardOwner')}
            {...form.getInputProps('cardOwner')}
            data={form.getInputProps('cardOwner').defaultValue && [{
              value: form.getInputProps('cardOwner').defaultValue,
              label: t(`user.cardOwner.options.${form.getInputProps('cardOwner').defaultValue}`),
            }]}
            disabled={true}
          />
        </Grid.Col>
        <Grid.Col span={9}>
          <Radio.Group
            name={'cardLostCase'}
            label={t('user.cardLostCase.label')}
            value={form.getInputProps('cardLostCase').defaultValue}
          >
            <Group mt={'xs'}>
              <Radio
                label={t('user.cardLostCase.options.BASIC_SECURITY')}
                value={'BASIC_SECURITY'}
                disabled={true}
              />
              <Radio
                label={t('user.cardLostCase.options.FAMILY_SECURITY')}
                value={'FAMILY_SECURITY'}
                disabled={true}
              />
              <Radio
                label={t('user.cardLostCase.options.NO_SECURITY')}
                value={'NO_SECURITY'}
                disabled={true}
              />
            </Group>
          </Radio.Group>
        </Grid.Col>
      </Grid>
    </Box>
  )
}

export default CardCard;